import Vue from 'vue'
import App from './App'
import router from './router'
// import store from '.store/store.js'


import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import axios from "axios";      //引入axios
Vue.prototype.$axios=axios;
import VueAxios from "vue-axios";
Vue.use(VueAxios, axios)
import Cookies from "js-cookie";

import './assets/Icon_New/iconfont.css'
import * as echarts from 'echarts';
Vue.prototype.$echarts = echarts;
Vue.use(echarts)
import ElementResizeDetectorMaker from "element-resize-detector";
Vue.prototype.$erd = ElementResizeDetectorMaker();

import less from 'less'
Vue.use(less)



// axios.defaults.baseURL = '/api';
// axios.defaults.baseURL = '/';
// axios.defaults.baseURL = 'https://assert.hyhdit.com';
axios.defaults.baseURL = 'http://47.96.19.229:8988';
// axios.defaults.baseURL = 'http://192.168.100.190:8988'; 
axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8';
axios.defaults.headers.get['Content-Type'] = 'application/json;charset=UTF-8';
axios.defaults.headers.common['Authorization'] = sessionStorage.getItem("Authorization");

Vue.use(ElementUI);
Vue.config.productionTip = false




/* eslint-disable no-new */
new Vue({
  axios,
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(res => res.meta.requireAuth)) { // 验证是否需要登陆
    var code=Cookies.get("Authorization");
    if (code) { // 查询本地存储信息是否已经登陆
      next();
    } else {
      next({
        path: '/', // 未登录则跳转至login页面
        redirect:  '/wait_Index' // 登陆成功后回到当前页面，这里传值给login页面，to.fullPath为当前点击的页面
        });
    }
  } else {
    next();
  }
})



axios.interceptors.request.use(
  config => {
    if (Cookies.get("Authorization")) {
      config.headers.Authorization = Cookies.get("Authorization");
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  });



axios.interceptors.response.use(
  config => {
    return config;
  },
  error => {
      ElementUI.Message({
          message: error.response.data.message,
          type: 'error'
      });
    return Promise.reject(error);
  });


Vue.filter('formateDate', function(date) {
  // 获取传入的日期时间
 const nDate = new Date(date)
  // 获取传入日期的年份
  const year = nDate.getFullYear();
  // 获取传入日期的月份，从0开始，加1到正常月份
  const month = (nDate.getMonth() + 1).toString().padStart(2,0);
  // 获取传入日期的日子
  const day = nDate.getDay().toString().padStart(2,0);

  // 获取传入日期的小时
  const hh = nDate.getHours().toString().padStart(2,0);
  // 获取传入日期的分钟
  const mm = nDate.getMinutes().toString().padStart(2,0);
  // 获取传入日期的秒数
  const ss = nDate.getSeconds().toString().padStart(2,0);

  // 返回日期格式
  return `${year}-${month }-${day} ${hh}:${mm}:${ss}`
})



// WEBPACK FOOTER //
// ./src/main.js